// extracted by mini-css-extract-plugin
export default {"Message":"Message_Message__9J77u","Success":"Message_Success__EOXBg","Error":"Message_Error__enLsC","Info":"Message_Info__i8NKf","Warning":"Message_Warning__-Hw5d"};